<template>
  <div>
    <v-data-table :items="statistics" :pagination.sync="paginationSync" :headers="playerStatisticsHeaders" style="overflow: scroll" hide-actions disable-initial-sort>
      <template slot="items" slot-scope="{ item }">
        <td style="height: 25px">{{ item.noShirt }}</td>
        <td style="display: flex; align-items: center; text-align: left; height: 25px; cursor: pointer;" @click.stop="showDialog(item)">
          <f-flag :code="item.federationCode" :height="20"></f-flag>
          {{ item.teamNamePlayer }}
        </td>
        <td style="height: 25px">{{ item.setExcellent }}</td>
        <td style="height: 25px">{{ item.setFault }}</td>
        <td style="height: 25px">{{ item.setContinue }}</td>
        <td style="height: 25px">{{ item.setTotalAttempts }}</td>
      </template>
    </v-data-table>

    <PlayerModal :show="show" :selectedPlayer="selectedPlayer" @close="show = false; selectedPlayer = null" />
  </div>
</template>

<script>
import Flag from '@/components/Flag'
import PlayerModal from '@/components/MatchLive/PlayerModal/PlayerModal.vue'

export default {
  props: ['statistics'],

  components: {
    PlayerModal,
    'f-flag': Flag,
  },

  data: () => ({
    paginationSync: {
      sortBy: 'setExcellent',
      descending: true,
      rowsPerPage: -1,
    },
    playerStatisticsHeaders: [
      { text: '#', value: 'noShirt', align: 'center', sortable: true, },
      { text: 'Name', value: 'teamNamePlayer', align: 'center', sortable: true, },
      { text: 'RUNNING SETS', value: 'setExcellent', align: 'center', sortable: true, },
      { text: 'FAULTS', value: 'setFault', align: 'center', sortable: true, },
      { text: 'STILL SETS', value: 'setContinue', align: 'center', sortable: true, },
      { text: 'TOTAL ATTEMPTS', value: 'setTotalAttempts ', align: 'center', sortable: true, },
    ],
    show: false,
    selectedPlayer: null,
  }),

  methods: {
    showDialog (item) {
      this.show = true
      this.selectedPlayer = item
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/MatchLive/StatisticsByPlayer/BestSetter.vue